import React from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";
import "./InvitationCard.scss";
import InfoCircleIcon from "../../../global/img/InfoCircleIcon";

class InvitationCard extends React.Component {
  render() {
    const { legalBusinessName } = this.props;
    return (
      <div className="invitation-card">
        <div className="invitation-card-inner">
          <div className="invitation-card-row">
            <div className="invitation-card-column">
              <h4 className="invitation-item-first-header">
                <p className="invitation-item">LEGAL BUSINESS NAME</p>
                {legalBusinessName}
              </h4>
            </div>
            <div className="invitation-card-column">
              <h5 className="invitation-item-header right-column-float">
                <p className="invitation-item-right">INVITED BY</p>
                {this.props.senderGivenName} {this.props.senderFamilyName}
              </h5>
            </div>
          </div>
          <div className="invitation-card-row">
            <div className="invitation-card-column">
              <h5 className="invitation-item-header">
                <p className="invitation-item">FEIN</p>
                {this.props.fein}
              </h5>
            </div>
            <div className="invitation-card-column">
              <h5 className="invitation-item-header right-column-float">
                <p className="invitation-item-right">DATE INVITED</p>
                <span>
                  {this.props.date_requested
                    ? moment.tz(new Date(this.props.date_requested), "America/New_York").format("ddd MMM D YYYY")
                    : "n/a"}
                </span>
              </h5>
            </div>
          </div>
          <div className="invitation-card-row-bottom">
            <div className="invitation-card-column flex-end-bottom flex-end-offset-margin">
              <span className="invitation-icon">
                <InfoCircleIcon color={"#55575b"} />
              </span>
              <span className="invitation-info">Invitations expire 7 days after the date invited.</span>
            </div>
            <div className="invitation-card-column flex-end-bottom">
              <button
                className="usa-button join-button"
                onClick={() => {
                  this.props.openModal("accept", this.props.invitation);
                }}
              >
                Join Network
              </button>
              <button
                className="usa-button usa-button--outline decline-invitation-button"
                onClick={() => {
                  this.props.openModal("decline", this.props.invitation);
                }}
              >
                Decline Invitation
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const senderGivenName = props.invitation.firstName ? props.invitation.firstName : "N/A";
  const senderFamilyName = props.invitation.lastName ? props.invitation.lastName : "N/A";
  const legalBusinessName = props.invitation.legalBusinesName ? props.invitation.legalBusinesName : "N/A";
  const fein = props.invitation.fein ? props.invitation.fein : "N/A";
  return {
    openModal: props.onClick,
    invitation: props.invitation,
    senderGivenName: senderGivenName,
    senderFamilyName: senderFamilyName,
    legalBusinessName: legalBusinessName,
    fein: fein,
    date_requested: props.invitation.date_requested,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvitationCard);
